{
  "dismiss": "Atmesti"
}
